import './App.css';
import Routes from './components/Routes';
import { BrowserRouter } from "react-router-dom"
import { AppContext } from './context/AppContext';
import Sidebar from './components/Sidebar';
import { useContext } from 'react';
import { ToastContainer } from 'react-toastify';

function App() {
  const { login } = useContext(AppContext);
  return (
    <div className="App">
      <div className="pageWrapper">
        <main>
          <div className="">
            <div className="row" style={{margin:"unset"}}>
              <BrowserRouter>
                {login.isLogin && <div className="col-xl-2 col-lg-3">
                  <Sidebar />
                </div>}
                <div className={login.isLogin ? "col-xl-10 col-lg-9" : ""}>
                  <Routes />
                </div>
              </BrowserRouter>
            </div>
          </div>
        </main>
        <ToastContainer
          position="top-right"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick={false}
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="light"
        />
      </div>
    </div>
  );
}

export default App;
